var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"ai-image-button",attrs:{"src":_vm.current,"alt":""},on:{"mouseover":function($event){_vm.current = _vm.pressed},"mouseout":function($event){_vm.current = _vm.idle},"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }